export default "__VITE_ASSET__TKzAf6HX__"